import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { Appointment } from 'src/app/core/interfaces/appointment/appointment';
import { ApiService } from 'src/app/core/services/api/api.service';

@Component({
  selector: 'app-appointment-list',
  templateUrl: './appointment-list.component.html',
  styleUrls: ['./appointment-list.component.scss'],
})
export class AppointmentListComponent implements OnInit {
  @Input() apptStatus: string;
  statusMessage: string;
  statusNumber: number;

  displayedColumns: string[] = [
    'appointmentId',
    'customer',
    'assignedName',
    'startTimeUTC',
    'endTimeUTC',
    'jobAddress',
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  apptArray: Appointment[] = [];
  dataSource: MatTableDataSource<Appointment>;

  isLoading: boolean = true;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();
    // this.getAppointments(this.apptStatus);
    this.route.paramMap.subscribe((params) => {
      this.apptStatus = params.get('status') as string;
      this.getAppointments(this.apptStatus);
    });
  }

  getAppointments(status: string) {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();

    if (status) {
      switch (status) {
        case 'scheduledAppointmentBacklog':
          this.statusNumber = 0;
          this.statusMessage = 'Scheduled Appointment Backlog';
          break;
      }
    }

    if (this.apptStatus != undefined) {
      this.apiService.getAppointmentsByStatus(this.statusNumber).subscribe({
        next: (appts) => {
          this.isLoading = false;
          this.apptArray = appts;
          this.dataSource = new MatTableDataSource(this.apptArray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        },
        error: (e) => {
          this.isLoading = false;
          console.error(e);
        },
      });
    }
  }

  goToAppointment(row: Appointment) {
    this.router.navigate(['customers/' + row.customerId], {
      queryParams: {
        jobAddressId: row.jobAddressId,
        appointmentId: row.appointmentId,
      },
    });
  }

  filterAppointments(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
